module.exports = __webpack_public_path__ + "assets/img/healthy-question-icon.cb4ca338.png";